import axios from 'axios';
import { VideoEstudio, VideoEstudioCreate, VideoEstadisticas } from '../Models/VideoEstudio';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

class VideoEstudioService {
  private baseUrl = `${API_BASE_URL}/api/videos`;
  private adminUrl = `${API_BASE_URL}/api/admin/videos`;

  // ==================== MÉTODOS PARA USUARIOS ====================

  /**
   * Obtener todos los videos activos
   */
  async getAll(): Promise<VideoEstudio[]> {
    const response = await axios.get(this.baseUrl);
    return response.data;
  }

  /**
   * Obtener video por ID
   */
  async getById(id: number): Promise<VideoEstudio> {
    const response = await axios.get(`${this.baseUrl}/${id}`);
    return response.data;
  }

  /**
   * Obtener videos por especialidad
   */
  async getByEspecialidad(especialidadId: number): Promise<VideoEstudio[]> {
    const response = await axios.get(`${this.baseUrl}/especialidad/${especialidadId}`);
    return response.data;
  }

  /**
   * Obtener videos por tema
   */
  async getByTema(temaId: number): Promise<VideoEstudio[]> {
    const response = await axios.get(`${this.baseUrl}/tema/${temaId}`);
    return response.data;
  }

  /**
   * Obtener videos filtrados
   */
  async getFiltered(especialidadId?: number, temaId?: number): Promise<VideoEstudio[]> {
    const params = new URLSearchParams();
    if (especialidadId) params.append('especialidadId', especialidadId.toString());
    if (temaId) params.append('temaId', temaId.toString());

    const response = await axios.get(`${this.baseUrl}/filtrar?${params.toString()}`);
    return response.data;
  }

  // ==================== MÉTODOS PARA ADMIN ====================

  /**
   * Obtener todos los videos (admin)
   */
  async getAllAdmin(): Promise<VideoEstudio[]> {
    const response = await axios.get(this.adminUrl);
    return response.data;
  }

  /**
   * Crear video (admin)
   */
  async create(video: VideoEstudioCreate): Promise<VideoEstudio> {
    const response = await axios.post(this.adminUrl, video);
    return response.data;
  }

  /**
   * Actualizar video (admin)
   */
  async update(id: number, video: VideoEstudioCreate): Promise<VideoEstudio> {
    const response = await axios.put(`${this.adminUrl}/${id}`, video);
    return response.data;
  }

  /**
   * Eliminar video (admin)
   */
  async delete(id: number): Promise<void> {
    await axios.delete(`${this.adminUrl}/${id}`);
  }

  /**
   * Toggle activo/inactivo (admin)
   */
  async toggleActivo(id: number): Promise<VideoEstudio> {
    const response = await axios.patch(`${this.adminUrl}/${id}/toggle`);
    return response.data;
  }

  /**
   * Buscar videos por título (admin)
   */
  async search(query: string): Promise<VideoEstudio[]> {
    const response = await axios.get(`${this.adminUrl}/search?q=${encodeURIComponent(query)}`);
    return response.data;
  }

  /**
   * Obtener estadísticas (admin)
   */
  async getStats(): Promise<VideoEstadisticas> {
    const response = await axios.get(`${this.adminUrl}/stats`);
    return response.data;
  }
}

export const videoEstudioService = new VideoEstudioService();
